import { SVGComponentPropsType } from './types';

type PropsType = Omit<SVGComponentPropsType, 'size'> & {
  length: number;
  thickness: number;
};

export default ({ color, length, thickness, ...props }: PropsType) => (
  <svg
    width={thickness}
    height={length}
    viewBox={`0 0 ${thickness} ${length}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line strokeWidth={thickness} stroke={color} x1="0" y1="0" x2="0" y2={length} />
  </svg>
);
